import {isNotNil} from 'ramda';

import {FilterFormAddress} from '../../../types/FilterFormData';
import {PriceReportType} from '../../../types/PriceReportType';
import {getDefaultValues} from '../../../utils/getDefaultValues';

export function getDefaultValuesWithResolvedAddress(
  priceReport: PriceReportType | undefined,
  resolvedAddress: FilterFormAddress | null
) {
  const defaultValues = getDefaultValues(priceReport);
  const priceReportAddress = priceReport?.vehicle.location?.address ?? null;

  if (isNotNil(resolvedAddress) && defaultValues.address?.label === priceReportAddress) {
    return {...defaultValues, address: resolvedAddress};
  }

  return defaultValues;
}
